import { observer } from 'mobx-react-lite'

import { RatingsTable } from '@/Containers/AssignmentSection/AssignmentContainer/Components/Sections/RatingsTable'

import { collectAssignments } from '../../Helpers/assignmentCollectors'

const driverName = (task: any): string => task?.driver?.fullName || task?.driver?.title || '—'

/**
 * Вкладка «Оцінки водія» картки заявки: оцінки всіх завдань тим самим `RatingsTable`, що й у
 * картці задачі (середня, рядки новіші зверху), з водієм і номером завдання в рядку.
 */
export const TaskRatingsTab = observer(({ formContext }: any) => {
    // Оцінка знає своє завдання через `_task`: RatingsTable приймає плоский список
    const ratings = collectAssignments(formContext).flatMap((task: any) =>
        (task.driverRatings ?? []).map((rating: any) => ({ ...rating, _task: task }))
    )

    return (
        <RatingsTable
            ratings={ratings}
            rowLabel={(rating) => (
                <>
                    {driverName(rating._task)}
                    {rating._task?.id !== null && rating._task?.id !== undefined && (
                        <span style={{ opacity: 0.65 }}> · #{rating._task.id}</span>
                    )}
                </>
            )}
        />
    )
})
